import request from '@/router/axios'

export function fetchRelateItemList(query,id) {
  return request({
    url: `/basic/admin/classification-relations/page/${id}`,
    method: 'get',
    params: query
  })
}

export function delItemObj(id) {
  return request({
    url: '/basic/admin/classification/' + id,
    method: 'delete'
  })
}
export function delRelateTagObj(id) {
  return request({
    url: '/basic/admin/classification-relations/' + id,
    method: 'delete'
  })
}

export function putItemObj(obj) {
  return request({
    url: '/basic/admin/classification',
    method: 'put',
    data: obj
  })
}

export function getAllClassification() {
  return request({
    url: '/basic/admin/classification/all',
    method: 'get',
  })
}

export function addNewClassfication(obj) {
  return request({
    url: '/basic/admin/classification',
    method: 'post',
    data: obj
  })
}

export function approveClassfication (id) {
  return request({
    url: `/basic/admin/classification/approve/${id}`,
    method: 'put'
  })
}

export function rejectClassfication (id) {
  return request({
    url: `/basic/admin/classification/reject/${id}`,
    method: 'put'
  })
}


//批量添加关联标签
export function addRelationClassification(tagRelations) {
  return request({
    url: '/basic/admin/classification-relations/add',
    method: 'post',
    data: tagRelations
  })
}

// 同步缓存
export function syncClassificationCache(data) {
  return request({
    url: '/basic/admin/classification-relations/sync-cache',
    method: 'post',
    data,
  })
}

// 清除缓存
export function removeClassificationCache(data) {
  return request({
    url: '/basic/admin/classification-relations/remove-cache',
    method: 'post',
    data,
  })
}